<main class="table-component-scss">
	<section class="w-full flex flex-row pl-2 pr-2 relative px-2">
		<div class="grid w-full overflow-hidden" [ngStyle]="{ gridTemplateColumns: getCS }">
			@for (col of table.columns; track $index) {
				@if (col.type === 'data') {
					<span class="text-xs select-none font-semibold" [matTooltip]="col.label">
						{{ col.label }}
					</span>
				}

				@if (col.type === 'search') {
					<div class="flex items-center w-full">
						<input
							id="inputSerchTable"
							#inputCheckSearch
							(change)="openSearch(inputCheckSearch, inputSearch)"
							class="absolute left-0 top-0 label-search hidden"
							type="checkbox"
							checked="checked"
						/>
					</div>
				}

				@if (col.type === 'action-delete') {
					<div [ngClass]="col.icon ? col.icon : ''" class="flex items-center w-full"></div>
				}

				@if (col.type === 'three-action') {
					<div [ngClass]="col.icon ? col.icon : ''"></div>
				}

				@if (col.type === 'none') {
					<div [ngClass]="col.icon ? col.icon : ''"></div>
				}

				@if (col.type === 'spacing') {
					<div [ngClass]="col.css ? col.css : ''" class="flex items-center w-full"></div>
				}
			}
			@if (table.details && table.details.length > 0) {
				<div class="w-20 flex justify-end pr-4"></div>
			}
			@if (!(table.details && table.details.length > 0)) {
				<div class="w-12 pr-4"></div>
			}
		</div>
	</section>

	@if ((!isSearchImage && !isLoaded) || isLoading) {
		<div class="min-h-48">
			<lbca-body-feedback place="module" feedbackIcon="searching" type="row">
				<ng-container rowMessagePrimary>{{ fieldsLabels['searching'] }}</ng-container>
			</lbca-body-feedback>
		</div>
	}

	@if (table.body.length === 0 && !firstSearchComplete && isLoaded) {
		<div class="min-h-48">
			<lbca-body-feedback place="module" type="panel"></lbca-body-feedback>
		</div>
	}

	@if (table.body.length === 0 && firstSearchComplete && isLoaded) {
		<div class="min-h-48">
			<lbca-body-feedback place="module" feedbackIcon="notfound" type="row">
				<ng-container rowMessagePrimary>{{ fieldsLabels['table-not-found'] }}</ng-container>
				<ng-container rowMessageSecondary>{{ fieldsLabels['table-try-new-search'] }}</ng-container>
			</lbca-body-feedback>
		</div>
	}

	@if (isLoaded && !editingMode && !isLoading) {
		<section class="flex flex-col relative w-full overflow-hidden gap-2 p-2">
			<ng-container *ngTryFor="let lane of table.body | sortTable: orderBy; let index = index">
				<div
					(click)="clickTableLine(lane)"
					(contextmenu)="contextTableLine($event, lane.id)"
					#itemList
					[ngClass]="{
						'hover:text-primary cursor-pointer': lineCickable,
					}"
					[class.opacity-50]="selectableMode"
					[class.opacity-100]="selectableMode && selectedLine === lane.trackerId"
					[class.ttfc-data-motion-prev]="paginationType === 'prev'"
					[class.motion-go-right]="paginationType === 'prev'"
					[class.ttfc-data-motion]="paginationType === 'next'"
					[class.motion-go-left]="paginationType === 'next'"
					[style.animation-delay.ms]="index * 60"
					class="w-full flex flex-col justify-center relative"
				>
					<ng-container *ngTryFor="let col of table.columns">
						@if (col.type === 'action-delete') {
							<div
								class="table-confirm-remove"
								[class.contentDelete]="lane.delete"
								[class.shake-horizontal]="checkLineDeslocation(lane)"
							>
								@if (!lane.isDeleting) {
									<lbca-icon
										name="lucide:trash"
										(click)="col.functionDelete(lane)"
										class="text-white cursor-pointer"
									/>
								}
								@if (lane.isDeleting) {
									<lbca-icon
										name="lucide:loader-circle"
										(click)="col.functionDelete(lane)"
										class="text-white cursor-pointer animate-spin"
									/>
								}
							</div>
						}
					</ng-container>
					<div
						class="grid w-full overflow-hidden text-sm table-line rounded-lg hover:shadow-sm flex-row h-10 !hover:border-2"
						[ngStyle]="{ gridTemplateColumns: getCS }"
						[class.shake-horizontal]="lane.confirmDelete"
						[class.select-line]="selectableMode && selectedLine === lane.trackerId"
					>
						@for (col of table.columns; track $index) {
							@if (
								col.type !== 'three-action' &&
								col.type !== 'action-delete' &&
								col.type !== 'spacing'
							) {
								<div class="flex items-center relative justify-center truncate px-1.5">
									@if (!col['templateRef'] && !col['field']) {
										<div
											class="table-col overflow-hidden flex justify-center items-center w-full min-h-10 text-xs text text-center"
										>
											@if (lane[col.name] && lane[col.name] !== '-') {
												<span
													[ngClass]="
														(col.css ? col.css + ' ' : '') +
														(col.enableCopy ? 'ml-9 pr-3' : '') +
														' no-select text-sm'
													"
												>
													{{ lane[col.name] }}
												</span>
											}
											@if (!lane[col.name] || lane[col.name] === '-') {
												<div class="w-2 h-px mt-2 bg-gray"></div>
											}
											@if (col.enableCopy && lane[col.name] && lane[col.name] !== '-') {
												<div
													title="Copiar!"
													(click)="copyToClipboard($event)"
													class="if-section-icon cursor-pointer"
												>
													<div class="if-icon-copy"></div>
												</div>
											}
										</div>
									}
									@if (!col['templateRef'] && col['field']) {
										<div class="table-col w-full min-h-10 text-xs text">
											<!-- 	remove on future release
                          <legalboxplus-icon
                            *ngIf="col['field'].type === 'ICON'"
                            [icon]="col['field'].icon"
                            [svg]="col['field'].svg"
                            [class]="col['field'].class"
                            [visible]="col['field'].visible"
                            [cardData]="cardInfo"
                            [value]="lane[col.name]"
                            >
                          </legalboxplus-icon>
                          -->
											@if (col['field'].type === 'FLAG-STATUS') {
												<legalboxplus-flag-status
													[value]="lane[col.name]"
												></legalboxplus-flag-status>
											}
											@if (col['field'].type === 'SELECT_TREE') {
												<lbca-select-tree-condensed
													[field]="col['field']"
													[cardData]="cardInfo"
													[value]="lane[col.name]"
												></lbca-select-tree-condensed>
											}
											@if (col['field'].type === 'HIDDEN') {
												<lbca-input-hidden
													[label]="col['field'].label"
													[defaultValue]="col['field'].defaultValue"
												></lbca-input-hidden>
											}
											@if (col['field'].type === 'INPUT_REF') {
												<legalboxplus-input-reference
													[cardData]="cardInfo"
													[field]="col['field']"
													[value]="lane[col.name]"
												></legalboxplus-input-reference>
											}
											@if (col['field'].type === 'TEXT') {
												<lbca-input-text
													[label]="col['field'].label"
													[disabled]="isDisabled"
													[tabeled]="true"
													[labeled]="false"
													[error]="[]"
													[require]="col['field'].required"
													[maskInput]="col['field'].mask"
													[editable]="col['field'].editable"
													[value]="lane[col.name]"
													(changeValue)="
														setValue($event, lane, col['field'].entityKey, col['field'].editable)
													"
												></lbca-input-text>
											}
											@if (col['field'].type === 'CALENDAR') {
												<lbca-date-picker
													[labeled]="false"
													[tabeled]="true"
													[disabled]="isDisabled"
													[label]="col['field'].label"
													[require]="col['field'].required"
													[error]="[]"
													[value]="lane[col.name]"
													[rules]="col['field'].rules"
													[disabledDateRules]="col['field'].disabledDateRules"
													[editable]="col['field'].editable"
													(changeValue)="
														setValue($event, lane, col['field'].entityKey, col['field'].editable)
													"
												>
													>
												</lbca-date-picker>
											}
											@if (col['field'].type === 'DATE_TIME') {
												<lbca-date-time-picker
													[labeled]="false"
													[tabeled]="true"
													[disabled]="isDisabled"
													[labelDate]="col['field'].labelDate"
													[labelTime]="col['field'].labelTime"
													[require]="col['field'].required"
													[error]="[]"
													[value]="lane[col.name]"
													[rules]="col['field'].rules"
													[disabledDateRules]="col['field'].disabledDateRules"
												></lbca-date-time-picker>
											}
											@if (col['field'].type === 'TIME') {
												<lbca-timepicker
													[labeled]="false"
													[tabeled]="true"
													[disabled]="isDisabled"
													[label]="col['field'].label"
													[require]="col['field'].required"
													[error]="[]"
													[value]="lane[col.name]"
												></lbca-timepicker>
											}
											@if (
												col['field'].auxEntity &&
												(col['field'].auxEntity.entityUrl !== null ||
													col['field'].auxEntity.listOptions)
											) {
												<lbca-entity-fields
													[forceType]="'SELECT_ONE'"
													[disabled]="isDisabled"
													[tabeled]="true"
													[labeled]="false"
													[field]="col['field']"
													[label]="col['field'].label"
													[error]="[]"
													[require]="col['field'].required"
													[cardData]="cardInfo"
													[value]="lane[col.name]"
												></lbca-entity-fields>
											}
										</div>
									}
									@if (col['templateRef']) {
										<ng-container
											[ngTemplateOutlet]="col.templateRef"
											[ngTemplateOutletContext]="{ $implicit: lane }"
										></ng-container>
									}
								</div>
							}
							@if (col.type === 'three-action') {
								<div
									(click)="stopPropagation($event)"
									class="flex items-center justify-end relative truncate px-1.5"
								>
									<label
										for="tertiary-actions-{{ index }}"
										class="flex items-center cursor-pointer h-6 w-6 justify-center relative"
									>
										<span class="tertiary-actions"></span>
										<input
											lbcaTableClickOutside
											id="tertiary-actions-{{ index }}"
											type="checkbox"
											class="hidden dropdown-select"
										/>
										<div
											class="w-196 top-[4px] max-h-224 bg-gray-100 text-xs right-0 box-sh-3 rounded absolute dropdown-content hidden show pt-4 pb-4"
										>
											<div class="w-full h-full ov-y-auto">
												<div
													*ngTryFor="let act of col.actions"
													(click)="act.function(lane)"
													class="w-full h-32 flex items-center pl-2 cursor-pointer text-sm"
												>
													{{ act.label }}
												</div>
											</div>
										</div>
									</label>
								</div>
							}
							@if (col.type === 'action-delete') {
								<div [ngClass]="col.css ? col.css : ''"></div>
							}
							@if (col.type === 'spacing') {
								<div [ngClass]="col.css ? col.css : ''"></div>
							}
						}
						@if (isEdit) {
							<div
								class="w-24 h-24 flex justify-center items-center cursor-pointer edit-hover"
								title="Editar"
							>
								<div
									class="svg-icon-edit w-12 h-12 icon-hover"
									(click)="clickEdit($event, lane)"
								></div>
							</div>
						}
						@if (table.details && table.details.length > 0 && !lane.notExpandable) {
							<div class="w-12 flex justify-end pr-4">
								<div
									class="svg-icon-angle bg-primary trs-eio-400 cursor-pointer"
									[class.trf-rotate-180]="lane.opened"
									(click)="lane.opened = !lane.opened"
								></div>
								@if (lane.checked && !isDisabled) {
									<div
										class="svg-icon-error bg-primary trs-eio-400 cursor-pointer"
										(click)="lane.opened = !lane.opened"
									></div>
								}
							</div>
						}
						@if (editParallel) {
							<span class="svg-icon-drafts icon-box-ct bg-primary span-icon"></span>
						}
						@if (!(table.details && table.details.length > 0 && !lane.notExpandable)) {
							<div class="w-12 pr-4"></div>
						}
					</div>
					@if (lane.opened && table.details) {
						<section
							class="table-details flex items-center rounded-lg flex-col z-1000 trs-eio-200 h-auto pt-25 pb-5 pl-24 pr-2 ml-4 mr-4 mb-4"
							[class.shake-horizontal]="lane.confirmDelete"
							[ngClass]="{
								'ml-10 w-10/12': checkLineDeslocation(lane),
								'w-full': !checkLineDeslocation(lane),
							}"
						>
							<div *ngTryFor="let row of table.details" class="flex w-full">
								<ng-container *ngTryFor="let field of row">
									@if (
										field.forceFieldDisplay ||
										(lane[field.entityKey] !== null && lane[field.entityKey] !== undefined) ||
										(field.type === 'FILES_DOWNLOAD' && !field.contextKey) ||
										(field.type === 'FILES_DOWNLOAD' && field.contextKey && lane[field.contextKey])
									) {
										<div class="mr-5 mb-6 w-full">
											<div [style.min-width.%]="field.size">
												@if (field.type === 'INPUT_REF') {
													<legalboxplus-input-reference
														[cardData]="cardInfo"
														[label]="field.label"
														[field]="field"
														[value]="lane[field.entityKey]"
													></legalboxplus-input-reference>
												}
												@if (field.type === 'TEXT') {
													<lbca-input-text
														[label]="field.label"
														[disabled]="isDisabled || field.disabled"
														[error]="[]"
														[require]="field.required"
														[maskInput]="field.mask"
														[value]="lane[field.entityKey]"
														(changeValue)="setValue($event, lane, field.entityKey)"
													></lbca-input-text>
												}
												@if (field.type === 'TEXTAREA') {
													<lbca-textarea
														[label]="field.label"
														[error]="[]"
														[disabled]="isDisabled || field.disabled"
														[value]="lane[field.entityKey]"
														[require]="field.required"
														[readonly]="field.readonly"
														(changeValue)="setValue($event, lane, field.entityKey)"
													></lbca-textarea>
												}
												@if (field.type === 'CALENDAR') {
													<lbca-date-picker
														[label]="field.label"
														[require]="field.required"
														[error]="[]"
														[disabled]="isDisabled || field.disabled"
														[value]="lane[field.entityKey]"
														(changeValue)="setValue($event, lane, field.entityKey)"
														[rules]="field.rules"
													></lbca-date-picker>
												}
												@if (field.type === 'TABLE_LIST') {
													<lbca-table-list
														[cardData]="cardInfo"
														[disabled]="true"
														[field]="field"
														[dataAttr]="dataAttr"
														[value]="lane[field.entityKey]"
														[allValues]="lane"
													></lbca-table-list>
												}
												@if (field.type === 'DATE_TIME') {
													<lbca-date-time-picker
														[value]="lane[field.entityKey]"
														[labelDate]="field.labelDate"
														[labelTime]="field.labelTime"
														[disabled]="isDisabled || field.disabled"
														[require]="field.required"
														[error]="[]"
														(changeValue)="setValue($event, lane, field.entityKey)"
														[rules]="field.rules"
														[disabledDateRules]="field.disabledDateRules"
													></lbca-date-time-picker>
												}
												@if (field.type === 'TIME') {
													<lbca-timepicker
														[label]="field.label"
														[require]="field.required"
														[disabled]="isDisabled || field.disabled"
														[error]="[]"
														[value]="lane[field.entityKey]"
														(changeValue)="setValue($event, lane, field.entityKey)"
													></lbca-timepicker>
												}
												@if (
													field.auxEntity &&
													(field.auxEntity.entityUrl !== null || field.auxEntity.listOptions)
												) {
													<lbca-entity-fields
														[forceType]="
															field.type === 'LIST_REF' || field.type === 'TABLE_SELECT_ONE'
																? field.type
																: 'SELECT_ONE'
														"
														[field]="field"
														[label]="field.label"
														[disabled]="isDisabled || field.disabled"
														[error]="[]"
														[require]="field.required"
														[value]="lane[field.entityKey]"
														[cardData]="cardInfo"
														(changeValue)="setValue($event, lane, field.entityKey)"
													></lbca-entity-fields>
												}
												@if (field.type === 'TABLE_FILES_DOWNLOAD') {
													<lbca-input-text
														[label]="field.label"
														[error]="[]"
														[require]="field.required"
														[disabled]="isDisabled || field.disabled"
														[maskInput]="field.mask"
														[value]="lane[field.entityKey]"
														(changeValue)="setValue($event, lane, field.entityKey)"
													></lbca-input-text>
												}
												@if (field.type === 'FILES_DOWNLOAD') {
													<lbca-files-download
														[disabled]="isDisabled || field.disabled"
														[configuration]="field"
														[cardData]="cardInfo"
														[context]="lane"
													></lbca-files-download>
												}
												@if (field.type === 'COMMENT_FORUM') {
													<lbca-comment-forum
														[contextValue]="lane[field.entityKey]"
														[label]="field.label"
														[configuration]="field"
														[dataAttr]="dataAttr"
														[disabled]="isDisabled || field.disabled"
														[error]="[]"
														[require]="field.required"
														[value]="data"
													>
														>
													</lbca-comment-forum>
												}
											</div>
										</div>
									}
								</ng-container>
							</div>
						</section>
					}
				</div>
			</ng-container>
		</section>
	}
	@if (isLoaded && table.body.length > 0) {
		<section class="w-full flex flex-row pl-6 pr-0.5 relative">
			<div class="flex items-center justify-between flex-row w-full overflow-hidden">
				<ng-container *ngTryFor="let col of table.columns; let i = index">
					@if (col.type === 'data') {
						<div
							class="flex overflow-hidden 123456"
							[ngClass]="col.cssFooter ? col.cssFooter : ''"
							[ngClass]="col.icon ? col.icon : ''"
						>
							@if (col['templateFooter']) {
								<ng-container [ngTemplateOutlet]="col.templateFooter"></ng-container>
							}
						</div>
					}
					@if (
						col.type === 'search' ||
						col.type === 'three-actio=n' ||
						col.type === 'none' ||
						col.type === 'spacing'
					) {
						<div class="flex items-center justify-center h-10"></div>
					}
				</ng-container>
			</div>
		</section>
	}

	@if (table.config?.pagination && table.body.length > 0) {
		<lbca-pagination
			[class.op-0]="false"
			[actualPage]="1"
			(selectedPage)="selectedPage($event)"
			(orientation)="orientation($event)"
			[hideMaxPages]="table.config?.pagination?.hideMaxPages || false"
			[maxPages]="table.config.pagination.totalPagesValue"
		></lbca-pagination>
	}
</main>

<ng-template #templateCopy>
	<div class="text-base text-gray-900 flex items-center justify-center show">
		Copiado!
		<div class="emojis-happy icon-box ml-16"></div>
	</div>
</ng-template>

<!-- <ng-template #ParallelTaskTemplate>
	<section class="flex flex-row modal-padding">
		<lbca-parallel-task
			class="w-full min-w-220"
			[taskType]="editConfiguration.type"
			[processId]="dataAttr.processNumber"
			[initialData]="initialData"
			(ngOnDestroy)="modalngOnDestroy()"
			[taskId]="this.dataAttr.bpmIdCard"
			[editConfiguration]="editConfiguration"
			[hasTask]="false"
			(outputData)="saveData($event)"
			(modalEventEmitter)="modalEventListener()"
		></lbca-parallel-task>
	</section>
</ng-template> -->
